import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';

const MaterialSubDivider = ({ title }) => {
  return(
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        width: '100%', 
        mt: 1 
        }}
      >
      <Divider
        sx={{
          flexGrow: 1,
          ml: 2,
          mr: 0,
          '&::before, &::after': {
            borderColor: 'grey.600',
          },
        }}
      >
        <Typography
          component="h6"
          variant="h6"
          sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}
          color={'text.secondary'}
        >
          {title}
        </Typography>
      </Divider>
    </Box>
  );
};

MaterialSubDivider.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MaterialSubDivider;